import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentBranding } from '../models/document-branding.model';

@Component({
  selector: 'app-quotation-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './quotation-header.component.html',
  styleUrls: ['./quotation-header.component.scss']
})
export class QuotationHeaderComponent {
  private _branding: DocumentBranding | null = null;

  @Input()
  set branding(val: DocumentBranding | null) {
    if (val) {
      this._branding = {
        ...val,
        headerContactLeft: 68,
        headerContactWidth: 30
      };
    } else {
      this._branding = null;
    }
  }
  get branding(): DocumentBranding | null {
    return this._branding;
  }

  @Input() vendorDetails: any = null;
}
